import { render, staticRenderFns } from "./screen-select.vue?vue&type=template&id=32fb79c0&"
import script from "./screen-select.vue?vue&type=script&lang=js&"
export * from "./screen-select.vue?vue&type=script&lang=js&"
import style0 from "./screen-select.vue?vue&type=style&index=0&id=32fb79c0&prod&lang=less&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports